// src/hooks/useLangParam.js
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

function normLang(v) {
  if (!v || typeof v !== 'string') return null;
  const s = v.toLowerCase().slice(0, 2);
  return s === 'de' || s === 'en' ? s : null;
}

export default function useLangParam() {
  const { i18n } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  // 1) Beim Mount: URL > localStorage > aktuelles i18n
  useEffect(() => {
    const urlLang = normLang(searchParams.get('lang'));
    const saved = normLang(localStorage.getItem('language') || localStorage.getItem('preferred_lang'));
    const desired = urlLang || saved || normLang(i18n.language) || 'de';

    // i18n auf desired umstellen (falls abweichend)
    if (i18n.language !== desired) {
      i18n.changeLanguage(desired);
    }

    // URL lang=desired ergänzen (ohne andere Params zu verlieren)
    if (!urlLang || urlLang !== desired) {
      const next = new URLSearchParams(searchParams);
      next.set('lang', desired);
      setSearchParams(next, { replace: true });
    }

    // axios + localStorage vorbereiten
    axios.defaults.headers.common['Accept-Language'] = desired;
    try {
      localStorage.setItem('language', desired);
      localStorage.setItem('preferred_lang', desired);
    } catch {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // nur einmal beim Mount

  // 2) Wenn i18n-Sprache später wechselt (z. B. Switcher): URL, axios, LS nachziehen
  useEffect(() => {
    const current = normLang(i18n.language) || 'de';

    // URL aktualisieren, aber restliche Params behalten
    const existing = normLang(searchParams.get('lang'));
    if (existing !== current) {
      const next = new URLSearchParams(searchParams);
      next.set('lang', current);
      setSearchParams(next, { replace: true });
    }

    axios.defaults.headers.common['Accept-Language'] = current;
    try {
      localStorage.setItem('language', current);
      localStorage.setItem('preferred_lang', current);
    } catch {}
  }, [i18n.language, searchParams, setSearchParams]);
}
